import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Slide from '@mui/material/Slide';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function LoaderModal({ show, setShow }) {

  const handleClose = () => {
    setShow(false);
  };

  return (
    <div>
      <Dialog
        open={show}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description" sx={{ textAlign: 'center' }}>
            <Box sx={{ display: 'flex' }}>
              <CircularProgress color="success" />
                Loading...
            </Box>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}